import { gsap } from 'gsap/gsap-core';

import { ConsumerPage } from './ConsumerPage';
document.addEventListener('DOMContentLoaded', function () {
  //window.requestAnimationFrame(function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new ConsumerPage();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });
  // });
});
